import * as React from 'react';

import loginUtil from './login.js'

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import IconButton from "@mui/material/IconButton";
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

import CloseIcon from "@mui/icons-material/Close";

export const tableToAuthAgainst = "busyness_auth"
export const fieldToAuthAgainst = "authenticated"

const userErrMsgs = {
  emptyLoginField: "Username or Password is empty.",
  badCredentials: "Username or Password not recognised.",
  serviceOrNetworkFailure: "Server or network failure, please try again later or contact GLA support.",
  notAuthorised: "Not authorised to access this private data. Please contact GLA support if you think this is in error.",
}

const GLATextField = styled(TextField) ({
  '& label': {
    color: '#6F7E8C',
  },
  '& label.Mui-focused': {
    color: '#6F7E8C',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#B2BAC2',
  },
  '& .MuiOutlinedInput-root': {
    color: '#6F7E8C',
    '& fieldset': {
      color: '#6F7E8C',
      borderColor: '#6F7E8C',
    },
    '&:hover fieldset': {
      borderColor: '#6F7E8C',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#6F7E8C',
    },
  },
});

const LoginModal = ({ isOpen, close, setToken }) => {
  const [username, setUsername] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [userErrMsg, setUserErrMsg] = React.useState("")

  const attemptLogin = async (e) => {
    e.preventDefault()

    const un = username
    const pw = password

    if (!un || !pw) {
      setUserErrMsg(userErrMsgs.emptyLoginField)
      return
    }

    resetForm()

    const token = await logUserIn(un, pw)
    if (userErrMsg) {
      return
    }

    if (!token) {
      setUserErrMsg(userErrMsgs.badCredentials)
      return
    }
    
    const hasAuth = await checkUserHasAuth(token)
    if (userErrMsg) {
      return
    }

    if(hasAuth) {
      setToken(token)
      closeModal()
    } else {
      setUserErrMsg(userErrMsgs.notAuthorised)
    }
  }

  const logUserIn = (un, pw) => {
    return loginUtil.generateGis2LoginToken(un, pw)
      .catch((e) => {
        reportServerOrNetworkFailure(e)
        return null
      })
  }

  const checkUserHasAuth = (token) => {
    return loginUtil.doesGis2TokenPermitAccess(token, tableToAuthAgainst, fieldToAuthAgainst)
      .catch((e) => {
        reportServerOrNetworkFailure(e)
        return false
      })
  }

  const reportServerOrNetworkFailure = (e) => {
    console.error("Server or network failure.")
    console.error(e)
    setUserErrMsg(userErrMsgs.serviceOrNetworkFailure)
  }

  const resetForm = () => {
    document.getElementById("login-password").value = ""
  }

  const closeModal = () => {
    resetForm()
    close()
  }

  const updateUsername = (e) => {
    e.preventDefault();
    setUsername(e.target.value)
    setUserErrMsg("")
  }

  const updatePassword = (e) => {
    e.preventDefault();
    setPassword(e.target.value)
    setUserErrMsg("")
  }

  const renderTitleBox = () => {
    return (
      <Box sx={{
        bgcolor: "#353D42",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "18px",
        p: "1rem",
        mb: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <span>Please Log In</span>
        <IconButton
          aria-label="Close login form"
          onClick={closeModal}
          size="medium"
          variant="contained">
          <CloseIcon />
        </IconButton>
      </Box>
    )
  }

  const renderTextField = (id, label, onChange, type='text') => {
    return (
      <GLATextField
        onChange={onChange}
        autoComplete="off"
        id={id}
        label={label}
        variant="outlined"
        type={type}
        sx={{
          m: "0 1rem 1rem",
        }} />
    )
  }

  const renderLoginButton = () => {
    return (
      <Box>
        <Button
          type="submit"
          variant="contained"
          onClick={attemptLogin}
          sx={{
            bgcolor: "#323b3f",
            color: "#fff",
            m: "0 1rem",
            '&:hover': {
              backgroundColor: '#00AEEF'
            }
          }}>
          Log In
        </Button>
      </Box>
    )
  }

  const renderErrorMessage = () => {
    if (!userErrMsg) {
      return undefined
    }

    return (
      <Box sx={{
        color: "#f00",
        m: "1rem 1rem 0",
        textAlign: "center"
      }}>
        {userErrMsg}
      </Box>
    )
  }

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <form id="login-form">
        <FormControl>
          <Box sx={{
            position: 'fixed',
            top: '50vh',
            left: '50vw',
            transform: 'translate(-50%, -50%)',
            bgcolor: '#f5f5f5',
            width: 325,
            pb: "1rem",
            display: "flex",
            flexDirection: "column",
          }}>
            {renderTitleBox()}
            {renderTextField("login-username", "Username", updateUsername)}
            {renderTextField("login-password", "Password", updatePassword, 'password')}
            {renderLoginButton()}
            {renderErrorMessage()}
          </Box>
        </FormControl>
      </form>
    </Modal>
  );
}

export default LoginModal;